import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

import { Customer } from '@/features/auth/domain/customer'
import { Features } from '@/utils/featureFlag/features'

export type RouterContext = {
  isReady?: boolean
  isCustomerActive?: boolean
  isFeatureEnabled?: (flag: Features) => boolean
  customer?: Customer
  queryClient?: QueryClient
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component() {
    return (
      <>
        <Outlet />
        {import.meta.env.DEV ? (
          <>
            <TanStackRouterDevtools />
            <ReactQueryDevtools />
          </>
        ) : null}
      </>
    )
  },
})
